import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import SuccessStories from "@/pages/SuccessStories";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/success-stories")({
  head: () => seoHead("/success-stories"),
  component: () => (
    <AuthGate><SuccessStories /></AuthGate>
  ),
});
